import { Close } from '@mui/icons-material';
import { IconButton, InputAdornment, TextField, TextFieldProps } from '@mui/material';
import React from 'react';

export interface TextFieldElementProps extends Omit<TextFieldProps, 'defaultValue' | 'onChange'> {
  id?: string;
  defaultValue?: any;
  readOnly?: boolean;
  showClearBtn?: boolean;
  onChange?: any;
}

const TextFieldElement = React.forwardRef<HTMLDivElement, TextFieldElementProps>(
  (props: TextFieldElementProps, ref: any) => {
    const { id, readOnly, required, showClearBtn, value, onChange, sx, ...rest } = props;

    return (
      <TextField
        ref={ref}
        inputProps={{
          autoComplete: 'off',
        }}
        size="small"
        fullWidth
        variant="outlined"
        {...rest}
        sx={{
          '&:hover': {
            '& .clear-btn': {
              display: 'flex',
            },
          },
          ...sx,
        }}
        value={value}
        onChange={onChange}
        InputProps={{
          readOnly: readOnly,
          ...rest?.InputProps,
          endAdornment: (
            <>
              {value && !readOnly && !rest.disabled && showClearBtn ? (
                <InputAdornment position="end" sx={{ display: 'none' }} className="clear-btn">
                  <IconButton size="small" onClick={() => onChange && onChange('')}>
                    <Close />
                  </IconButton>
                </InputAdornment>
              ) : null}
              {rest?.InputProps?.endAdornment}
            </>
          ),
        }}
        InputLabelProps={{
          shrink: true,
          required: required,
          ...rest.InputLabelProps,
        }}
      />
    );
  },
);

export default TextFieldElement;
